import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../stylesh/ContactHome.css';

const ContactHome = () => {
  const navigate = useNavigate();
  return (
    <div className="contact-home">
      <div className="contact-home-content">
        <h1 className="contact-home-title">
          To make your IT agile, modern, and scalable!
        </h1>
        <button className="contact-home-btn"
        onClick={() => navigate("/company/contact")}
        >
          Contact Us
        </button>
      </div>
    </div>
  );
};

export default ContactHome;